import { gql } from '@apollo/client';

export const GENERATE_PRESIGNED_URL = gql`
  query PresignedUrl($releaseId: Int, $userId: String, $releaseFileId: Int) {
    presignedUrl(releaseId: $releaseId, userId: $userId, releaseFileId: $releaseFileId)
  }
`
